import { DrawerFields, FieldHeaders, TableFields } from '../../components/table/fieldsConfigTypes';
import Device from '../../models/device';

export const permissionTableFields: TableFields<Device> = [
  undefined, // For the checkbox column
  'hostname',
  'label',
  'serial_number',
  'ip_private',
  'owner'
];

export const permissionDrawerFields: DrawerFields<Device> = [
  { field: 'model', label: 'Model' },
  { field: 'memory_current', label: 'Current Memory' },
  { field: 'owner', label: 'Owner' },
  { field: 'ip_public', label: 'Public IP' },
  { field: 'mac', label: 'MAC Address' },
  { field: 'os_version', label: 'OS Version' },
  { field: 'cpu_temperature', label: 'CPU Temp' },
];

export const permissionFieldHeaders: FieldHeaders = {
  'hostname': 'Hostname',
  'label': 'Label',
  'ip_private': 'Private IP',
  'serial_number': 'Serial Number',
  'owner': 'Owner'
};